"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVersion1toVersion2 = void 0;
const updateVersion1toVersion2 = (configuration) => {
    return Object.assign(Object.assign({}, configuration), { version: 2, main: Object.assign(Object.assign({}, configuration.main), { playerConfiguration: Object.assign(Object.assign({}, configuration.main.playerConfiguration), { addTranscriptButton: false, lockPlayerBar: false, ccOnByDefault: false, largeCenterPlayIcon: false, rectangleCenterPlayIcon: false, logoOverlay: false }) }) });
};
exports.updateVersion1toVersion2 = updateVersion1toVersion2;
//# sourceMappingURL=v2.js.map